module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_green.9beec6bf.svg";